declare global {
  interface Window {
    auxiliaryWindow?: {
      isConnected?: () => Promise<boolean>;
      location?: string;
    };
  }
}

type SetLocationArgs = {
  url?: string;
};

export const useAuxiliaryWindow = () => {
  const setAuxiliaryWindowLocation = ({ url = '' }: SetLocationArgs) => {
    if (!window.auxiliaryWindow) {
      return;
    }

    window.auxiliaryWindow.location = url;
  };

  const isAuxiliaryWindowConnected: () => Promise<boolean> = async () =>
    window.auxiliaryWindow?.isConnected ? window.auxiliaryWindow?.isConnected() : Promise.resolve(false);

  return { setAuxiliaryWindowLocation, isAuxiliaryWindowConnected };
};

export default useAuxiliaryWindow;
